<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div>
  <form [formGroup]="frmFilterDataHistory">
    <div class="grid">
      <div class="col md:col-4">
        <p-calendar
          [firstDayOfWeek]="1"
          dateFormat="dd/mm/yy"
          formControlName="rangeDates"
          selectionMode="range"
          [readonlyInput]="true"
          styleClass="w-full"
          placeholder="Filtra per data..."
          [showClear]="true"
          appendTo="body"></p-calendar>
      </div>
      <div class="col md:col-4">
        <input
          pInputText
          formControlName="serial_number"
          placeholder="Filtra per serial number..."
          ngClass="w-full" />
      </div>
      <div class="col md:col-4">
        <input
          pInputText
          formControlName="asset_code"
          placeholder="Filtra per codice asset..."
          ngClass="w-full" />
      </div>
      <div class="col md:col-4">
        <input
          pInputText
          formControlName="code_inventory"
          placeholder="Filtra per codice inventario..."
          ngClass="w-full" />
      </div>
      <div class="col md:col-4">
        <p-autoComplete
          [suggestions]="suggestedUsers"
          (completeMethod)="filterUsers($event)"
          field="fullName"
          id="id"
          class="flex-grow-1"
          dataKey="id"
          [emptyMessage]="'Nessun risultato trovato'"
          formControlName="related_user"
          [forceSelection]="true"
          [showClear]="true"
          styleClass="w-full"
          placeholder="Filtra per utente..."
          [showClear]="true"></p-autoComplete>
      </div>
      <div class="col md:col-4">
        <input
          pInputText
          formControlName="notes"
          placeholder="Filtra per note..."
          ngClass="w-full" />
      </div>
      <div class="col md:col-4">
        <div class="flex align-items-center gap-1 h-full">
          <label for="all">Tutti</label>
          <p-radioButton
            name="status"
            formControlName="status"
            value="all"
            inputId="all"></p-radioButton>
        </div>
      </div>
      <div class="col md:col-4">
        <div class="flex align-items-center gap-1 h-full">
          <label for="lost">Persi</label>
          <p-radioButton
            name="status"
            formControlName="status"
            value="lost"
            inputId="lost"></p-radioButton>
        </div>
      </div>
      <div class="col md:col-4">
        <div class="flex align-items-center gap-1 h-full">
          <label for="present">Presenti</label>
          <p-radioButton
            name="status"
            formControlName="status"
            value="present"
            inputId="present"></p-radioButton>
        </div>
      </div>
      <div class="col-12">
        <p-button
          styleClass="butt w-full"
          icon="pi pi-filter-slash"
          (click)="clearAssetDataHisotry(dt4, $event)"
          pTooltip="Elimina filtri"
          tooltipPosition="top"></p-button>
      </div>
    </div>
  </form>
  <p-table
    [paginator]="true"
    [value]="asset_data_history"
    #dt4
    [rows]="25"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadAssetDataHistory($event)"
    [totalRecords]="totalRecordsDataHistory"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th>Data</th>
        <th>Serial number</th>
        <th>Codice asset</th>
        <th>Codice inventario</th>
        <th>Perso</th>
        <th>Guasto</th>
        <th>Rip. on center</th>
        <th>Attivo</th>
        <th>Ufficio</th>
        <th>Codice ufficio</th>
        <th>Commessa</th>
        <th>Consegna</th>
        <th>Utente</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-a>
      <tr>
        <td>{{ a.created_on | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ a.serial_number || '-' }}</td>
        <td>{{ a.asset_code || '-' }}</td>
        <td>{{ a.inventory_code || '-' }}</td>
        <td class="text-center">
          <span
            class="p-tag"
            [class.p-tag-danger]="a.lost"
            [class.p-tag-success]="!a.lost"
            >{{ a.lost ? 'Sì' : 'No' }}</span
          >
        </td>
        <!-- guasto e rip. on center: NULL per le righe precedenti alla registrazione di questi campi -->
        <td class="text-center">
          <span
            *ngIf="a.faulty === true || a.faulty === false; else none"
            class="p-tag"
            [class.p-tag-danger]="a.faulty"
            [class.p-tag-success]="!a.faulty"
            >{{ a.faulty ? 'Sì' : 'No' }}</span
          >
        </td>
        <td class="text-center">
          <span
            *ngIf="a.repair_on_center === true || a.repair_on_center === false; else none"
            class="p-tag"
            [class.p-tag-warning]="a.repair_on_center"
            [class.p-tag-success]="!a.repair_on_center"
            >{{ a.repair_on_center ? 'Sì' : 'No' }}</span
          >
        </td>
        <td>
          <p class="text-center">
            <span
              [class.p-tag]="true"
              [class.p-tag-success]="a.active"
              [class.p-tag-danger]="!a.active"
              class="mr-1">
              {{ a.active ? 'Sì' : 'No' }}
            </span>
          </p>
        </td>
        <td>{{ a.office || '-' }}</td>
        <td>{{ a.office_code || '-' }}</td>
        <td>
          <span class="font-bold"> {{ a.related_agreement?.name || '-' }} </span><br />
          <small class="grey-text pr-1">
            {{ a.related_agreement?.identifier || '-' }}
          </small>
        </td>
        <td>
          <ng-container *ngIf="a.related_delivery; else none">
            <a
              target="_blank"
              class="butt p-button p-button-link"
              href="/main/consegne/dettaglio/{{ a.related_delivery.id }}"
              >Consegna n.{{ a.related_delivery.id }}</a
            ><br />
            <a
              target="_blank"
              class="butt p-button p-button-link"
              href="/main/ordini-cliente/dettaglio/{{ a.related_delivery.order_customer.id }}"
              >Ordine cliente {{ a.related_delivery.order_customer.identifier }}</a
            >
          </ng-container>
        </td>

        <td>{{ a.related_user?.name || '-' }} {{ a.related_user?.last_name || '-' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="13"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #none>-</ng-template>
